<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="12" md="10">
      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent="register" autocomplete="off">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Registrácia</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <v-card-text>Údaje vyplňuj riadne a pravdivo. Nepravdivo vyplnený formulár o tvojich údajoch môže byť
              dôvodom na zrušenie tvojho profilu a tým všetkých aktivít a práv na tejto stránke.</v-card-text>
            <v-card-text>

              <v-card class="mb-3">
                <v-card-title>Základné údaje</v-card-title>
                <v-card-text>

                  <v-row>
                    <v-col cols="12" md="12">
                      <validation-provider v-slot="{ errors }" name="Prihlasovacie meno" :rules="{
                        required: true,
                        username: '^[A-z0-9]+$'
                      }">
                        <v-text-field v-model="form.username" :error-messages="errors" label="Prihlasovacie meno"
                          name="login" hint="Prihlasovacie meno sa môže skladať iba z písmen bez diakritiky a čísel."
                          prepend-icon="mdi-account" type="text" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">

                      <validation-provider v-slot="{ errors }" name="Email" vid="email1"
                        :rules="{ required: true, email: true }">
                        <v-text-field v-model="form.email" :error-messages="errors" label="Email" name="email"
                          prepend-icon="mdi-email" hint="Napríklad boris@nasehnutie.sk" type="text" @click.right.prevent
                          @copy.prevent @paste.prevent />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Email znovu" rules="confirmed:email1">

                        <v-text-field v-model="form.email2" :error-messages="errors" label="Email znovu" name="email2"
                          prepend-icon="mdi-email" type="text" hint="Napríklad boris@nasehnutie.sk" @click.right.prevent
                          @copy.prevent @paste.prevent />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Heslo" rules="required|min:10" vid="password1">

                        <v-text-field id="password" v-model="form.password" :error-messages="errors" label="Heslo"
                          name="password" prepend-icon="mdi-lock"
                          hint="Heslo si zvol bezpečné. Minimálna dĺžka je 10 znakov."
                          :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" @click.right.prevent @copy.prevent
                          @paste.prevent />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Heslo znovu" rules="confirmed:password1">

                        <v-text-field id="password" v-model="form.password2" :error-messages="errors"
                          label="Heslo znovu" name="password2" prepend-icon="mdi-lock"
                          :type="show2 ? 'text' : 'password'"
                          hint="Heslo si zvol bezpečné (to isté ako predtým). Minimálna dĺžka je 10 znakov."
                          @click:append="show2 = !show2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                          @click.right.prevent @copy.prevent @paste.prevent />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Meno" rules="required">

                        <v-text-field v-model="form.first_name" :error-messages="errors" label="Meno" name="first_name"
                          prepend-icon="mdi-account" type="text" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Priezvisko" rules="required">

                        <v-text-field v-model="form.last_name" :error-messages="errors" label="Priezvisko"
                          name="last_name" prepend-icon="mdi-account" type="text" />
                      </validation-provider>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-select v-model="form.gender" label="Pohlavie" prepend-icon="mdi-account" :items="selects" />
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
              <v-card>
                <v-card-title>Detaily</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="12">
                      <validation-provider v-slot="{ errors }" name="Telefónne číslo" vid="phone1"
                        rules="required|international_phone">
                        <v-text-field v-model="form.phone_number" :error-messages="errors" label="Telefónne číslo"
                          name="phone_number" prepend-icon="mdi-phone" type="text"
                          hint="Telefónne číslo zadávaj v medzinárodnom tvare. Napríklad +421910123456." required
                          @click.right.prevent @copy.prevent @paste.prevent
                          @blur="normalizePhoneNumber('phone_number')"></v-text-field>
                      </validation-provider>
                    </v-col>

                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12">
                      <validation-provider v-slot="{ errors }" name="Telefónne číslo znovu"
                        :rules="{ confirmed: 'phone1' }">
                        <v-text-field v-model="form.phone_number2" :error-messages="errors"
                          label="Telefónne číslo znovu" name="phone_number2"
                          hint="Telefónne číslo zadávaj v medzinárodnom tvare (to isté číslo čo predtým)."
                          prepend-icon="mdi-phone" type="text" required @click.right.prevent @copy.prevent
                          @paste.prevent @blur="normalizePhoneNumber('phone_number2')"></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <validation-provider v-slot="{ errors }" name="Ulica" rules="required">

                        <v-text-field v-model="form.address_street" :error-messages="errors" label="Ulica"
                          name="address_street" prepend-icon="mdi-map-marker" type="text" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Číslo" rules="required">

                        <v-text-field v-model="form.address_number" :error-messages="errors" label="Číslo"
                          name="address_number" prepend-icon="mdi-map-marker" type="text" />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="Mesto/Obec" rules="required">

                        <v-autocomplete v-model="form.address_town" :error-messages="errors" :items="itemsTown"
                          :search-input.sync="searchTown" item-text="name" item-value="name" label="Mesto/Obec"
                          placeholder="Mesto/Obec" hint="Začni písať a vyber si potom zo zoznamu."
                          prepend-icon="mdi-map-marker" @change="townChanged($event)" return-object
                          hide-no-data></v-autocomplete>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <validation-provider v-slot="{ errors }" name="PSČ" rules="required">

                        <v-text-field v-model="form.address_zip_code" :error-messages="errors" label="PSČ"
                          name="address_zip_code" prepend-icon="mdi-map-marker" type="text" />
                      </validation-provider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="form.address_okres" disabled label="Okres" name="address_okres"
                        prepend-icon="mdi-map-marker" type="text" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="form.address_kraj" disabled label="Kraj" name="address_kraj"
                        prepend-icon="mdi-map-marker" type="text" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field v-model="form.address_country" disabled label="Štát" name="address_country"
                        prepend-icon="mdi-flag" type="text" />
                    </v-col>
                  </v-row>

                  <v-row align="center">
                    <v-col cols="8" md="10">
                      <validation-provider v-slot="{ errors }" name="IBAN" vid="iban1" :rules="{
                        required: false,
                        iban: true
                      }">
                        <v-text-field :error-messages="errors" v-model="form.bank_account" class="custom-iban"
                          label="IBAN - NEPOVINNÝ údaj pre registráciu" name="bank_account" prepend-icon="mdi-bank"
                          type="text" @input="onIBANInput"
                          hint="Zadaj IBAN svojho účtu. Napríklad SK10 0000 0000 1234 5678 1234 alebo DE89 3704 0044 0532 0130 00" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" md="2">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small v-bind="attrs" v-on="on" color="error" outlined>
                            DÔLEŽITÉ
                          </v-btn>
                        </template>
                        <v-card><v-card-text>
                            <p>Ak si vyplníš aj IBAN a overíš sa prostredníctvom platby z banky, tak budeš mať viac
                              výhod oproti tým, ktorí sa
                              takýmto spôsobom neoveria. A zároveň nás môžeš aj trochu podporiť.</p>

                            <p>Pýtaš sa načo je nám číslo tvojho účtu (IBAN)?
                              Na overenie tvojej identity prostredníctvom bankového účtu. Prostredníctvom prijatej
                              platby z tvojho účtu dokážeme
                              jednoducho spárovať teba ako skutočnú osobu s sobou, ktorá bude vystupovať na týchto
                              platformách a tým výrazne
                              znížime a eliminujeme vytváranie falošných identít, ktoré by mohli negatívne ovplyvňovať
                              komentáre v diskusiách. A
                              o to nám tu predsa ide. Aby sme tu mali čo najkorektnejšie informácie od skutočných osôb a
                              nie od imaginárnych
                              trolov.</p>

                            <p> Číslo tvojho účtu a ani číslo účtu nikoho sa nedá zneužiť. Len heslá a pin kódy k účtu
                              sa dajú zneužiť.
                              A TIE OD TEBA NEŽIADAME! A nikdy ani nebudeme.</p>

                            <p> Veď už len plynárne, elektrárne, či mobilní operátori majú zverejnené svoje čísla IBAN
                              na každej faktúre a aj na
                              ich webových sídlach a to oni na účtoch majú podstatne viac peňazí ako my. Hocikde dávaš
                              číslo tvojho účtu a keď
                              niekomu pošleš peniaze, tak to číslo účtu prijímateľ vidí.</p>

                            <p>My tu chceme využiť moderné informačné technológie na to aby sme AUTOMATIZOVANE, teda bez
                              nároku na ďalšie
                              personálne zaťaženie, overili tvoju unikátnu identitu. Prebieha to tak, že ak sa v našom
                              systéme objaví platba z
                              účtu, ktorý sa zhoduje s tým číslom účtu IBAN, ktoré uvedieš sem pri registrácií, bude
                              táto platba priradená k
                              tebe. Aj vo svojom profile sa Ti táto platba AUTOMATIZOVANE pripočíta k celkovej sume,
                              ktorú si zaslal/a v náš
                              prospech a to aj opakovane – teda je to kumulatívny údaj. Náš systém komunikuje s bankovým
                              systémom a platby sa
                              spárujú. Preto Ťa prosíme aby si správne uviedol/a číslo tvojho účtu a pri každej platbe
                              používal/a ako VS
                              (variabilný symbol) aj tvoje unikátne ID (identifikačné číslo), ktoré sa Ti vytvorí
                              automaticky po tejto úspešnej
                              registrácií a budeš ho vidieť vo svojom profile.</p>

                            <p> Ďakujeme za pochopenie.</p>

                            <p>Boris Wagner</p>
                          </v-card-text></v-card>
                      </v-menu>
                    </v-col>

                  </v-row>

                  <v-row align="center">
                    <v-col cols="8" md="10">
                      <validation-provider v-slot="{ errors }" name="IBAN" :rules="{
                        required: false,
                        confirmed: 'iban1'
                      }">
                        <v-text-field :error-messages="errors" v-model="form.bank_account2" class="custom-iban"
                          label="IBAN znovu - NEPOVINNÝ údaj pre registráciu" name="bank_account2"
                          hint="Zadaj IBAN svojho účtu (ten istý čo predtým). Napríklad SK10 0000 0000 1234 5678 1234 alebo DE89 3704 0044 0532 0130 00"
                          prepend-icon="mdi-bank" type="text" @input="onIBANInput2" />
                      </validation-provider>
                    </v-col>
                    <v-col cols="4" md="2">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn small v-bind="attrs" v-on="on" color="error" outlined>
                            DÔLEŽITÉ
                          </v-btn>
                        </template>
                        <v-card><v-card-text>
                            <p>Ak si vyplníš aj IBAN a overíš sa prostredníctvom platby z banky, tak budeš mať viac
                              výhod oproti tým,
                              ktorí sa takýmto spôsobom neoveria. A zároveň nás môžeš aj trochu podporiť.</p>

                            <p>Pýtaš sa načo je nám číslo tvojho účtu (IBAN)?
                              Na overenie tvojej identity prostredníctvom bankového účtu. Prostredníctvom prijatej
                              platby z tvojho účtu
                              dokážeme jednoducho spárovať teba ako skutočnú osobu s sobou, ktorá bude vystupovať na
                              týchto platformách a
                              tým výrazne znížime a eliminujeme vytváranie falošných identít, ktoré by mohli negatívne
                              ovplyvňovať
                              komentáre v diskusiách. A o to nám tu predsa ide. Aby sme tu mali čo najkorektnejšie
                              informácie od
                              skutočných osôb a nie od imaginárnych trolov.</p>

                            <p> Číslo tvojho účtu a ani číslo účtu nikoho sa nedá zneužiť. Len heslá a pin kódy k účtu
                              sa dajú zneužiť.
                              A TIE OD TEBA NEŽIADAME! A nikdy ani nebudeme.</p>

                            <p> Veď už len plynárne, elektrárne, či mobilní operátori majú zverejnené svoje čísla IBAN
                              na každej faktúre a
                              aj na ich webových sídlach a to oni na účtoch majú podstatne viac peňazí ako my. Hocikde
                              dávaš číslo tvojho
                              účtu a keď niekomu pošleš peniaze, tak to číslo účtu prijímateľ vidí.</p>

                            <p>My tu chceme využiť moderné informačné technológie na to aby sme AUTOMATIZOVANE, teda bez
                              nároku na ďalšie
                              personálne zaťaženie, overili tvoju unikátnu identitu. Prebieha to tak, že ak sa v našom
                              systéme objaví
                              platba z účtu, ktorý sa zhoduje s tým číslom účtu IBAN, ktoré uvedieš sem pri registrácií,
                              bude táto platba
                              priradená k tebe. Aj vo svojom profile sa Ti táto platba AUTOMATIZOVANE pripočíta k
                              celkovej sume, ktorú si
                              zaslal/a v náš prospech a to aj opakovane – teda je to kumulatívny údaj. Náš systém
                              komunikuje s bankovým
                              systémom a platby sa spárujú. Preto Ťa prosíme aby si správne uviedol/a číslo tvojho účtu
                              a pri každej
                              platbe používal/a ako VS (variabilný symbol) aj tvoje unikátne ID (identifikačné číslo),
                              ktoré sa Ti vytvorí
                              automaticky po tejto úspešnej registrácií a budeš ho vidieť vo svojom profile.</p>

                            <p> Ďakujeme za pochopenie.</p>

                            <p>Boris Wagner</p>
                          </v-card-text></v-card>
                      </v-menu>
                    </v-col>

                  </v-row>

                </v-card-text>
              </v-card>

              <v-checkbox v-model="agreement" label="Súhlasím s podmienkami používania tejto stránky" name="agreement">
              </v-checkbox>
              <a href="https://docs.google.com/gview?embedded=true&url=https://api.nasehnutie.sk/uploads/cc7ffb9f-9079-4ff0-829d-a49b6ad89671.pdf"
                target="_blank">Podmienky používania stránky nasehnutie.sk</a>
              <g-d-p-r-consent v-model="agreement_gdpr"></g-d-p-r-consent>

              <v-card-actions>
                <v-spacer />
                <v-btn :disabled="!agreement || invalid || !agreement_gdpr" color="primary" @click="register">
                  Registrovať sa
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </validation-observer>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { APIService } from "@/http/APIService.js";
import { mapGetters } from "vuex";
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import { required, regex, confirmed, email, min, alpha_num } from 'vee-validate/dist/rules'
import GDPRConsent from '../components/GDPRConsent.vue';
import VueMask from 'v-mask'
// Import libphonenumber-js
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js'

Vue.use(VueMask);

const apiService = new APIService();

setInteractionMode('eager')

extend('required', {
  ...required,
  message: '{_field_} nemôže byť prázdne',
})

// New international phone validation using libphonenumber-js
extend('international_phone', {
  validate: (value) => {
    if (!value) return false;

    try {
      // Define allowed countries
      const allowedCountries = [
        // European countries
        'AD', 'AL', 'AT', 'BA', 'BE', 'BG', 'BY', 'CH', 'CZ', 'DE', 'DK', 'EE',
        'ES', 'FI', 'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LI', 'LT',
        'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO',
        'RS', 'RU', 'SE', 'SI', 'SK', 'SM', 'UA', 'VA', 'XK',
        // USA and Canada
        'US', 'CA',
        // Australia and New Zealand
        'AU', 'NZ',
        // Iceland (already included in Europe but mentioned specifically)
        'IS'
      ];

      // Parse the phone number
      const phoneNumber = parsePhoneNumber(value);

      if (!phoneNumber) {
        return false;
      }

      // Check if the country is in the allowed list
      if (!allowedCountries.includes(phoneNumber.country)) {
        return false;
      }

      // Validate the phone number
      return phoneNumber.isValid();

    } catch (error) {
      return false;
    }
  },
  message: 'Telefónne číslo musí byť platné číslo z Európy, USA, Kanady, Austrálie, Nového Zélandu alebo Islandu. Napríklad +421910123456 (SK), +420987654321 (CZ), +49301234567 (DE), +1234567890 (USA/CA), +61412345678 (AU), +64211234567 (NZ), +354123456 (IS)',
});

extend('iban', {
  validate: (value) => {
    if (!value) return true; // Allow empty since it's optional
    return validateIBAN(value);
  },
  message: 'IBAN musí byť v platnom formáte. Napríklad SK31 1200 0000 1987 4263 7541 alebo DE89370400440532013000',
});

extend('username', {
  ...regex,
  message: '{_field_} môže obsahovať iba písmená bez diakritiky a čísla. Napríklad nbusr123',
})

extend('email', {
  ...email,
  message: 'Emailová adresa nie je korektná. Napríklad info@nasehnutie.sk',
})

extend('confirmed', {
  ...confirmed,
  message: 'Znovu zadaná hodnota položky {_field_} sa nezhoduje',
})

extend('min', {
  ...min,
  message: 'Minimálna dĺžka hesla je 10 znakov',
})

extend('alpha_num', {
  ...alpha_num,
  message: 'Prihlasovacie meno sa môže skladať iba z čísiel a písmen bez diakritiky. Napríklad nbusr123',
})

function validateIBAN(iban) {
  // Remove spaces and convert to uppercase
  const cleanIban = iban.replace(/\s/g, '').toUpperCase();

  // Check if IBAN has correct length (15-34 characters)
  if (cleanIban.length < 15 || cleanIban.length > 34) {
    return false;
  }

  // Check if IBAN starts with 2 letters followed by 2 digits
  if (!/^[A-Z]{2}[0-9]{2}/.test(cleanIban)) {
    return false;
  }

  // Move first 4 characters to end
  const rearranged = cleanIban.slice(4) + cleanIban.slice(0, 4);

  // Replace letters with numbers (A=10, B=11, ..., Z=35)
  const numericString = rearranged.replace(/[A-Z]/g, (char) => {
    return (char.charCodeAt(0) - 55).toString();
  });

  // Check if mod 97 equals 1
  return mod97(numericString) === 1;
}

// Helper function for mod 97 calculation on large numbers
function mod97(string) {
  let remainder = 0;
  for (let i = 0; i < string.length; i++) {
    remainder = (remainder * 10 + parseInt(string[i])) % 97;
  }
  return remainder;
}

export default {
  props: {
    source: String,
  },
  data() {
    return {
      show1: false,
      show2: false,
      loading: false,
      drawer: null,

      mask: null,

      agreement: false,
      agreement_gdpr: false,

      form: {
        username: "",
        password: "",
        password2: "",
        email: "",
        email2: "",
        first_name: "",
        last_name: "",
        bank_account: "",
        bank_account2: "",
        phone_number: "",
        phone_number2: "",
        gender: "",
      },
      selects: [
        { text: "Muž", value: "MAN" },
        { text: "Žena", value: "WOMAN" },
      ],

      searchTown: null,
      itemsTown: []
    };
  },

  watch: {
    searchTown(val) {
      this.searchTownApi(val);
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },

  components: {
    ValidationProvider,
    ValidationObserver,
    GDPRConsent
  },

  methods: {
    normalizePhoneNumber(fieldName) {
      // Get the current value from the form object
      const numberToParse = this.form[fieldName];

      // Don't do anything if the field is empty
      if (!numberToParse) {
        return;
      }

      try {
        // Parse the number. This might throw an error for invalid input.
        const phoneNumber = parsePhoneNumber(numberToParse);

        // If it's a valid number, update the form field with the E.164 format.
        // E.164 is the international standard (+421950478232).
        if (phoneNumber && phoneNumber.isValid()) {
          this.form[fieldName] = phoneNumber.format('E.164');
        }
      } catch (error) {
        // If parsing fails (e.g., user types "abc"), do nothing.
        // The vee-validate rule will show the error message.
        console.error("Phone number parsing error:", error.message);
      }
    },

    formatIBAN(value) {
      if (!value) return '';
      // Remove all spaces and convert to uppercase
      const cleaned = value.replace(/\s/g, '').toUpperCase();
      // Add space every 4 characters
      return cleaned.replace(/(.{4})/g, '$1 ').trim();
    },

    onIBANInput(event) {
      const formatted = this.formatIBAN(event.target.value);
      this.form.bank_account = formatted;
    },

    onIBANInput2(event) {
      const formatted = this.formatIBAN(event.target.value);
      this.form.bank_account2 = formatted;
    },

    townChanged(event) {
      if (event.okres.name)
        this.form.address_okres = event.okres.name;
      if (event.okres.kraj.name)
        this.form.address_kraj = event.okres.kraj.name;
      if (event.okres.kraj.krajina.name)
        this.form.address_country = event.okres.kraj.krajina.name;
    },

    searchTownApi(val) {
      apiService
        .searchObec(val)
        .then((response) => {
          this.itemsTown = response;
        });
    },

    register() {
      this.$refs.observer.validate().then((valid) => {
        if (!valid) {
          return;
        }

        this.loading = true;
        if (this.form.address_town && this.form.address_town.name)
          this.form.address_town = this.form.address_town.name;

        if (!this.form.bank_account)
          this.form.bank_account = null;

        apiService.register(this.form)
          .then((response) => {
            this.form = response;
            this.$router.push({ "path": "/register_verify" });
          })
          .catch(() => { })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style>
.custom-iban .v-label {
  color: red !important;
  opacity: 1;
}
</style>
